export default "__VITE_ASSET__CduffE$F__"